import {module} from 'modujs';

//const JS_ID = 'ze-snippet';
const JS_ID = 'chatbase-snippet';
const API_URL = 'https://static.zdassets.com/ekr/snippet.js?key=fc9498d6-ff00-42cb-9114-a36daec75206';

let API_LOADED = null;
let API_LOADING = null;

function hasZE() {
    return (typeof window.zE === 'function');
}

/**
 * Zendesk Web Widget (Classic) Integration
 *
 * @link https://developer.zendesk.com/api-reference/widget/introduction/
 */
export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.addEventListener('modularloading', () => this.hide(), {
            once: true
        });

        if (this.hasAPI()) {
            this.show();
        } else {
            this.loadAPI();
        }
    }

    destroy() {
        this.hide();
    }

    hasAPI() {
        return API_LOADED;
    }

    loadAPI() {

        if (
            API_LOADED !== null ||
            API_LOADING ||
            hasZE() ||
            document.getElementById(JS_ID)
        ) {
            return;
        }

        API_LOADING = true;

        const script = document.createElement('script');

        script.id = JS_ID;
        //script.src = API_URL;

        script.onload = () => {
            API_LOADED = true;
            API_LOADING = false;
        };
        script.onerror = () => {
            API_LOADED = false;
            API_LOADING = false;
        };

        document.querySelector('body').classList.remove('chatbase-hidden');

        script.textContent = "(function () {\n" +
            "                                        if (!window.chatbase ||window.chatbase('getState')!=='initialized')\n" +
            "                                        {\n" +
            "                                            window.chatbase = (...arguments) => {\n" +
            "                                                if (!window.chatbase.q) {\n" +
            "                                                    window.chatbase.q = []\n" +
            "                                                }\n" +
            "                                                window.chatbase.q.push(arguments)\n" +
            "                                            };\n" +
            "                                            window.chatbase = new Proxy(window.chatbase, {\n" +
            "                                                get(target, prop) {\n" +
            "                                                    if (prop ==='q')\n" +
            "                                                    {\n" +
            "                                                        return target.q\n" +
            "                                                    }\n" +
            "                                                    return (...args) => target(prop, ...args)\n" +
            "                                                }\n" +
            "                                            })\n" +
            "                                        }\n" +
            "                                        const onLoad = function () {\n" +
            "                                            const script = document.createElement('script');\n" +
            "                                            script.src ='https://www.chatbase.co/embed.min.js';\n" +
            "                                            script.id='CBxfrHNKNzq2H4lUoFY5i';\n" +
            "                                            script.domain='www.chatbase.co';\n" +
            "                                            document.body.appendChild(script)};if(document.readyState==='complete'){onLoad()}else{window.addEventListener('load',onLoad)}})();"

        document.body.appendChild(script);
        
        API_LOADED = true;
        API_LOADING = false;
    }

    hide() {
        document.querySelector('body').classList.add('chatbase-hidden');
        /*if (this.hasAPI()) {
            window.zE?.('webWidget', 'hide');
        }*/
    }

    show() {
        document.querySelector('body').classList.remove('chatbase-hidden');
       /* if (this.hasAPI()) {
            window.zE?.('webWidget', 'show');
        }*/
    }
}
